import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const SizeChartModal = ({ isOpen, imageUrl, closeModal }) => {
  return (
    <div
      className={
        isOpen
          ? "fixed inset-0 flex items-center justify-center z-10"
          : "hidden"
      }
    >
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30 md:rounded-xl"></div>
      <div className="flex flex-col bg-white h-96 w-96 md:h-[500px] md:w-[500px] justify-center items-center z-50 rounded-lg">
        <div className="flex justify-end w-full mr-10 -mt-2">
          <p className="cursor-pointer text-lg" onClick={closeModal}>
            <FontAwesomeIcon icon={faXmark} />
          </p>
        </div>
        <img
          src={imageUrl}
          className="h-80 w-80 md:h-[430px] md:w-[430px] rounded-lg"
          alt="Full Size Image"
        />
      </div>
    </div>
  );
};

export default SizeChartModal;
